import type { IStorage } from "@/core/plugins/storage/Storage";
import { IUserProfileResponse } from "./types";
import { LocalStorageKeys } from "@/core/@types/types";

import { injectable, inject } from "inversify";
import "reflect-metadata";
import { DITypes } from "@/core/@types/types";

@injectable()
export class UserProfile {
  @inject(DITypes.STORAGE)
  private storage!: IStorage;

  response: IUserProfileResponse | undefined;

  handleUserProfile() {
    const hasData = this.response != undefined;

    if (!hasData) return false;

    this.storage.set(LocalStorageKeys.UserProfile, this.response);

    return true;
  }
}
